/*
* ぽちボタンクリック後の処理
*/ 

import { isAnyItzaiProductChecked, isItzaiProductChecked } from "./itzai.class"

class afrPostCMS {
  constructor(that) {
    this.that = that
    this.formName = "CMS"    
    this.that.$('.search_form_wrap').show()
    this.actionInit()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store
    const func = this.that.func

    //制作前共有
    store.commit('setValue', ['cms', 'input_cms_should_movie', $('input[name="cms_should_movie"]:checked').val(), 'cmsShouldMovie'])
    store.commit('setValue', ['cms', 'input_cms_products_num', $("#cmsProductsNum").val(), 'cmsProductsNum'])
    store.commit('setValue', ['cms', 'input_cms_shootDate', $("#shootDate_cms").val(), 'shootDate_cms'])
    store.commit('setValue', ['cms', 'input_cms_model_type', $('[name="cms_model_type"]:checked').val() || '', 'cmsModelType'])
    store.commit('setValue', ['cms', 'input_cms_version', func.textEscape($("#cmsVersion").val()), 'cmsVersion'])
    store.commit('setValue', ['cms', 'inputSharedMattersCMS', func.textEscape($('#sharedMatters_cms').val()), ''])
    store.commit('setValue', ['cms', 'inputShouldShootCMS', $('[name="shoot_yesNo_cms"]:checked').val(), ''])
    store.commit('setValue', ['cms', 'inputReasonNotShootCMS', func.textEscape($("#reasonNotShoot_cms").val()), ''])
    store.commit('setValue', ['cms', 'inputContractReasonCMS', func.textEscape($('#contractReason_cms').val()), ''])
    store.commit('setValue', ['cms', 'inputPersnalityCMS', func.textEscape($('#persnality_cms').val()), ''])
    store.commit('setValue', ['cms', 'inputConv', func.textEscape($('#conv_cms').val()), ''])
    store.commit('setValue', ['cms', 'inputHopeCMS', func.textEscape($('#hope_cms').val()), ''])

  }

  setVal (balanceInfoMsg) {
    const store = this.that.store
    // main.class.js 側の構築順によっては store の itzai.inputPlan が古い可能性があるため、
    // DOM の選択値から判定して Slack 文面の末尾を確実に付与する
    const $ = this.that.$
    const planId = $('[name="itzai_plan"]:checked').prop('id') || ''
    const isItzaiCorpOrComplete =
      planId === 'itzai_plan_corporate' ||
      planId === 'itzai_plan_complete'
    const isMainItzai = isItzaiProductChecked($)
    const cmsModelType = store.state.formData.cms.input_cms_model_type || ''
    const cmsVersionSuffix =
      !isMainItzai && isItzaiCorpOrComplete && cmsModelType === 'corporate'
        ? '（コーポレートプラン）'
        : !isMainItzai && isItzaiCorpOrComplete && cmsModelType === 'recruitment'
          ? '（採用型番）'
          : ''

    let sendVal = 
`
◎CMS
動画撮影：${store.state.formData.cms.input_cms_should_movie}
サイト制作数：${store.state.formData.cms.input_cms_products_num}
掲載希望日時：${store.state.formData.cms.input_cms_shootDate}
型番：${store.state.formData.cms.input_cms_version}${cmsVersionSuffix}
お客様共有事項：${store.state.formData.cms.inputSharedMattersCMS}
撮影有無：${store.state.formData.cms.inputShouldShootCMS}
撮影無し理由：${store.state.formData.cms.inputReasonNotShootCMS}
契約動機：${store.state.formData.cms.inputContractReasonCMS}
顧客人柄：${store.state.formData.cms.inputPersnalityCMS}
お客様との会話内容：${store.state.formData.cms.inputConv}
顧客希望：${store.state.formData.cms.inputHopeCMS}
`

    const contactValue = document.getElementById("contact_cms").value
    let contactInformation = ""
    if (contactValue) {
      contactInformation = `連絡先情報備考：${contactValue}`
    }
    sendVal = sendVal + contactInformation + '\n'
    store.commit('setTalknoteMessage', ['cms', sendVal])
  }

  actionInit() {
    const $ = this.that.$

    const isItzaiCorpOrCompletePlanSelected = () => {
      const planId = $('[name="itzai_plan"]:checked').prop('id') || ''
      const isItzaiChecked = isAnyItzaiProductChecked($)
      return (
        isItzaiChecked &&
        (planId === 'itzai_plan_corporate' || planId === 'itzai_plan_complete')
      )
    }

    const syncCmsModelTypeUi = () => {
      const enableModelType = isItzaiCorpOrCompletePlanSelected()
      const isMainItzai = isItzaiProductChecked($)
      const $modelTypeSection = $('#cmsModelTypeSection')
      const $versionInput = $('#cmsVersion')
      const $versionLabel = $('#cmsVersionLabel')
      const $versionHelp = $('#cmsVersionHelp')
      const selectedModelType = $('[name="cms_model_type"]:checked').val() || ''

      if (!enableModelType) {
        $modelTypeSection.addClass('-none').hide()
        $('[name="cms_model_type"]').prop('checked', false).removeClass('required')
        $versionInput.prop('readonly', false).removeClass('required')
        $versionLabel.text('型番')
        $versionHelp.addClass('-none').html('')
        return
      }

      if (isMainItzai) {
        $modelTypeSection.addClass('-none').hide()
        $('[name="cms_model_type"]').prop('checked', false).removeClass('required')
        $versionInput.prop('readonly', false).addClass('required')
        $versionLabel.text('型番')
        $versionHelp
          .removeClass('-none')
          .html('※ CMSコーポレート型番を選択してください。')
        return
      }

      $modelTypeSection.removeClass('-none').show()
      $('[name="cms_model_type"]').addClass('required')

      const modelType = selectedModelType

      if (modelType === 'recruitment') {
        $versionInput.prop('readonly', false).addClass('required')
        $versionLabel.text('型番（採用型番：自由記載）')
        $versionHelp
          .removeClass('-none')
          .html('※ 採用型番を選択時は、型番を自由記載してください。')
      } else if (modelType === 'corporate') {
        $versionInput.prop('readonly', false).addClass('required')
        $versionLabel.text('型番（コーポレート：自由記載）')
        $versionHelp
          .removeClass('-none')
          .html('※ コーポレートサイトを選択時は、「型番」もしくは「後日」と記載してください。')
      } else {
        $versionInput.prop('readonly', false).removeClass('required')
        $versionLabel.text('型番')
        $versionHelp
          .removeClass('-none')
          .html('※ 「コーポレートサイト」または「採用型番」を選択してください。')
      }
    }

    $("#form_ap").on("click", '[name="shoot_yesNo_cms"]', function() {

      let thisVal = $(this).prop("id")

      switch (thisVal) {
        case "shoot_yes_cms":
          $("#fildReasonNotShoot_cms").slideUp()
          $("#reasonNotShoot_cms").removeClass("required")
          $("#reasonNotShoot_cms").val("")
          break;

        case "shoot_no_cms":
          $("#fildReasonNotShoot_cms").slideDown()
          $("#reasonNotShoot_cms").addClass("required")
          break;
      }

    })

    $("#form_ap").on("change", '[name="cms_model_type"]', syncCmsModelTypeUi)
    $("#form_ap").on("change", '[name="itzai_plan"]', syncCmsModelTypeUi)
    $("#form_ap").on("change", '#formItzaiSelect, #formCMSSelect', syncCmsModelTypeUi)
    syncCmsModelTypeUi()
  }
}

export default {
  afrPostCMS
}